/**
 * Aviso de som bloqueado. Safari e Chrome no celular só tocam o áudio depois de um toque do
 * usuário; o LiveKit avisa quando isso aconteceu (`canPlayAudio`) e o botão chama `startAudio`.
 * Some sozinho assim que o som toca.
 */
import { useAudioPlayback } from '@livekit/components-react';
import { Volume2 } from 'lucide-react';
import { cn } from '@/lib/utils';

/** Parte visual, sem hooks. `className` reposiciona o aviso (no celular ele desce para não cobrir a prévia). */
export function AudioBlockedView({ onStart, className }) {
    return (
        <div
            role="status"
            className={cn(
                'absolute left-1/2 top-3 z-20 flex w-max max-w-[calc(100%-1rem)] -translate-x-1/2 items-center gap-3 rounded-3xl bg-neutral-800/95 py-1.5 pl-4 pr-1.5 text-sm leading-snug text-white shadow-lg',
                className,
            )}
        >
            <Volume2 className="h-4 w-4 shrink-0" aria-hidden="true" />
            <span className="min-w-0">O navegador bloqueou o som da chamada</span>
            <button
                type="button"
                onClick={onStart}
                className="shrink-0 rounded-full bg-cyan-500 px-3 py-1.5 text-xs font-semibold text-neutral-950 hover:bg-cyan-400 focus:outline-none focus-visible:ring-2 focus-visible:ring-white"
            >
                Ativar som
            </button>
        </div>
    );
}

export function AudioBlockedNotice({ className }) {
    const { canPlayAudio, startAudio } = useAudioPlayback();
    if (canPlayAudio) return null;
    return <AudioBlockedView onStart={startAudio} className={className} />;
}
